<template>
    <el-drawer
        title="众筹结款信息"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <div v-if="data1" class="group">
                <div class="page-group-title"><span>收款信息</span></div>
                <table class="info-table MT20" width="100%">
                    <tr>
                        <th>收款联系人姓名</th>
                        <td>{{data1.userName}}</td>
                        <th>收款联系人手机</th>
                        <td>{{data1.userTelephone}}</td>
                    </tr>
                    <tr>
                        <th>收款联系人邮箱</th>
                        <td>{{data1.userEmail}}</td>
                        <th>通讯地址</th>
                        <td>{{data1.address}}</td>
                    </tr>
                    <tr>
                        <th>银行</th>
                        <td>{{data1.bank}}</td>
                        <th>开户网点</th>
                        <td>{{data1.bankAddress}}</td>
                    </tr>
                    <tr>
                        <th>卡号</th>
                        <td>{{data1.bankCardId}}</td>
                        <th>账户名</th>
                        <td>{{data1.bankAccount}}</td>
                    </tr>
                    <tr v-if="data1.accountType">
                        <th>账户性质</th>
                        <td colspan="3">{{data1.accountType == 1 ? '企业' : '个人'}}</td>
                    </tr>
                </table>
            </div>
            <div v-if="data" class="group MT20">
                <div class="page-group-title"><span>结款参考</span></div>
                <table class="info-table MT20" width="100%">
                    <tr>
                        <th>众筹ID</th>
                        <td>{{data.id}}</td>
                        <th>众筹名称</th>
                        <td>{{data.title}}</td>
                    </tr>
                    <tr v-if="data.receivablesUserId">
                        <th>结款方</th>
                        <td>[{{$userType.get(data.receivablesUserType)}}]{{data.receivablesUserName}}</td>
                        <th>结款方ID</th>
                        <td>{{data.receivablesUserId}}</td>
                    </tr>
                    <tr>
                        <th>目标筹款金额</th>
                        <td>{{data.raiseMoneyFormat}}</td>
                        <th>支持次数</th>
                        <td>{{data.supportNum}}</td>
                    </tr>
                    <tr>
                        <th>已经筹款金额</th>
                        <td colspan="3" class="color-danger">{{data.raisedMoneyFormat}}</td>
                    </tr>
                </table>
            </div>
            <div v-if="data && data1" class="group MT20">
                <div class="page-group-title"><span>结款信息</span></div>
                <SettlementEdit v-if="drawerShow && data" ref="settlementEdit" :itemData.sync="data" :btnLoading.sync="btnLoading"></SettlementEdit>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button v-if="data && data.canAudi != 0" type="primary" @click="onSubmit()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>
<script>
import SettlementEdit from './settlementEdit';
export default {
    components:{SettlementEdit},
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            id:'',
            data:null,
            data1: null,
            dataLoading:false,
        }
    },
    methods:{
        close(){
            // if(this.$refs.formData) this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(id){
            this.id = id || '';
            // this.data = data;
            this.data1 = null;
            this.btnLoading = false;
            if(id){
                this.getData();
            }
            this.drawerShow = true;
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/raise/receivables/audi/raiseReceivablesInfo',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result || null;
                        this.data1 = result.receivablesInfo || null;
                    } else {
                        this.$message.error(msg || "获取结款信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取结款信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        onSubmit(){
            this.$refs.settlementEdit.onSubmit(() => {
                this.close();
                this.$emit('onUpdate');
            })
        }
    }
}
</script>